export const glossaryTerms = [
  {
    term: 'Annuity',
    definition: 'A financial product that pays out a fixed stream of payments to an individual, primarily used as an income stream for retirees.',
  },
  {
    term: 'Asset',
    definition: 'A resource with economic value that an individual, corporation, or country owns or controls with the expectation that it will provide a future benefit.',
  },
  {
    term: 'Bear Market',
    definition: 'A market condition in which the prices of securities are falling, and widespread pessimism causes the negative sentiment to be self-sustaining.',
  },
  {
    term: 'Bull Market',
    definition: 'A market condition in which the prices of securities are rising or are expected to rise. It is characterized by optimism and investor confidence.',
  },
  {
    term: 'Capital Gain',
    definition: 'An increase in the value of a capital asset (investment or real estate) that gives it a higher worth than the purchase price. The gain is not realized until the asset is sold.',
  },
  {
    term: 'Compound Interest',
    definition: 'The interest on a loan or deposit calculated based on both the initial principal and the accumulated interest from previous periods. "Interest on interest."',
  },
  {
    term: 'Cost Inflation Index (CII)',
    definition: 'A measure of inflation that is used for computing long-term capital gains from the sale of capital assets in India.',
  },
  {
    term: 'Diversification',
    definition: 'A risk management strategy that mixes a wide variety of investments within a portfolio. The rationale is that a portfolio of different kinds of assets will, on average, yield higher long-term returns and lower the risk of any individual holding.',
  },
  {
    term: 'Equity',
    definition: 'Represents the amount of money that would be returned to a company’s shareholders if all of the assets were liquidated and all of the company\'s debt was paid off. Also known as shares or stocks.',
  },
  {
    term: 'Goods and Services Tax (GST)',
    definition: 'An indirect tax used in India on the supply of goods and services. It is a comprehensive, multistage, destination-based tax.',
  },
  {
    term: 'House Rent Allowance (HRA)',
    definition: 'A component of a salary paid by an employer to an employee for accommodation expenses. A portion of HRA can be claimed as a tax deduction.',
  },
  {
    term: 'Liability',
    definition: 'A financial obligation or debt owed to another person or company. It represents a future sacrifice of economic benefits.',
  },
  {
    term: 'National Pension System (NPS)',
    definition: 'A voluntary, defined contribution retirement savings scheme designed to enable the subscribers to make optimum decisions for their future.',
  },
  {
    term: 'Public Provident Fund (PPF)',
    definition: 'A long-term investment scheme popular in India which offers tax benefits and a guaranteed rate of return.',
  },
  {
    term: 'Systematic Investment Plan (SIP)',
    definition: 'A method of investing in mutual funds where an investor can invest a fixed amount of money at regular intervals (e.g., monthly, quarterly).'
  }
];